<script>import Icon from '../Icon.svelte';
const iconNode = [["path", { "d": "M10 18l6 -6l-6 -6v12" }]];
</script>
<Icon name="caret-right" {...$$props} iconNode={iconNode}>
  <slot/>
</Icon>
